import { useContext } from 'react';

import { Box, Text, GoalIcon, u, colors } from '@ui';

import { LiveAnalysisTableContext } from './context';
import * as styles from './styles.css';

export const LiveAnalysisTableHeader = () => {
    const { parameters, isSetup } = useContext(LiveAnalysisTableContext);
    const columns = parameters.length;
    return (
        <>
            <Box className={styles.headerSet}>
                <Text variant="h3">Set</Text>
            </Box>
            {parameters.map((parameter) => {
                return (
                    <Box className={styles.headerParam} justifyContent="space-between" key={parameter.id}>
                        <Text variant="h3">{parameter.label}</Text>
                        <Box className={styles.headerParamRange}>
                            <Text variant="h3">{parameter.min}</Text>
                            <GoalIcon size={u(2)} color={colors.bluegray[700]} />
                            <Text variant="h3">{parameter.max}</Text>
                        </Box>
                    </Box>
                );
            })}
            <Box />
            {Array.from({ length: columns }).map((_, index) => (
                <Box key={index} className={styles.headerAvg}>
                    <Text variant="label">Avg.</Text>
                    {!isSetup && <Text variant="label">Hit-Rate</Text>}
                </Box>
            ))}
        </>
    );
};
